// extracted by mini-css-extract-plugin
export default {"DisclosureButton":"NavMenu_DisclosureButton__BoEqh","DisclosureTitle":"NavMenu_DisclosureTitle__bUk-l","IconWrapper":"NavMenu_IconWrapper__ADvkf"};